import { App as CapacitorApp } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";

let lastHandledUrl = "";

function normalizePath(routePath = "/") {
    if (!routePath) return "/";
    const normalized = routePath.replace(/\/+$/, "") || "/";
    return normalized.startsWith("/") ? normalized : `/${normalized}`;
}

function buildRouteLocation(url, router) {
    if (!url) return null;

    let parsedUrl;
    try {
        parsedUrl = new URL(url);
    } catch {
        return null;
    }

    const hashPath = parsedUrl.hash.startsWith("#/") ? parsedUrl.hash.slice(1) : "";
    const externalPath = hashPath || normalizePath(parsedUrl.pathname);
    const resolved = router.resolve({
        path: externalPath,
        query: Object.fromEntries(parsedUrl.searchParams.entries()),
    });

    if (!resolved.matched.length) return null;

    return {
        path: externalPath,
        query: Object.fromEntries(parsedUrl.searchParams.entries()),
    };
}

async function openUniversalLink(url, router, replace = false) {
    if (!url || url === lastHandledUrl) return;

    const target = buildRouteLocation(url, router);
    if (!target) return;

    lastHandledUrl = url;

    const currentFullPath = router.currentRoute.value.fullPath;
    const nextFullPath = router.resolve(target).fullPath;
    if (currentFullPath === nextFullPath) return;

    const action = replace ? "replace" : "push";
    await router[action](target);
}

export async function initUniversalLinks(router) {
    if (!Capacitor.isNativePlatform()) return;

    await CapacitorApp.addListener("appUrlOpen", async ({ url }) => {
        await openUniversalLink(url, router);
    });

    const launch = await CapacitorApp.getLaunchUrl().catch(() => null);
    await openUniversalLink(launch?.url, router, true);
}
